<template>
	<div id="app">
		<top-bar/>
    <div class="container">
      <router-view></router-view>
    </div>
	</div>
</template>

<script>
export default {
	computed: {
		showSpinner () {
			return this.$store.state.showSpinner;
		}
	}
};
</script>

<style lang="scss">
@import '../../node_modules/bootstrap/dist/css/bootstrap.css';
@import '../../node_modules/bootstrap-vue/dist/bootstrap-vue.css';
@import "../scss/index.scss";
</style>



// WEBPACK FOOTER //
// App.vue?4be339b2